import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: var(--vo-white);
  border-left: 4px solid ${({ $color }) => $color || 'var(--color-brand)'};
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 18px 20px;
  margin-bottom: 20px;
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 2px;
  color: ${({ $color }) => $color || 'var(--color-brand)'};

  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.h2`
  font-family: var(--font-secondary);
  font-size: 14px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0;
`

const Description = styled.p`
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--vo-slate);
  margin: 0;
  line-height: 1.5;
`

export const SectionBanner = ({ icon, title, description, color }) => (
  <Wrapper $color={color}>
    {icon && <IconWrapper $color={color}>{icon}</IconWrapper>}
    <Content>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Content>
  </Wrapper>
)

SectionBanner.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  color: PropTypes.string,
}
